import { ArrowForward, ArrowBackIos } from '@mui/icons-material'
import { Button } from '../FormControls/Button';
import { Stack } from '../FormControls/Stack';
import { useDispatch } from 'react-redux'
import { forward, backward, jump } from "../../../main/slices/routerSlice";
import { LoadingIcon } from '../FormControls/LoadingIcon';
import { useState } from 'react';

// beforeGoBack ALLOWS TO PERFORM AN ACTION TRIGGERED BY THE BACKWARD BUTTON AND IF IS SUCCESSFULL THE ROUTER WILL GO THE LAST SCREEN
// beforeSubmit ALLOWS TO PERFORM AN ACTION TRIGGERED BY THE FORWARD BUTTON AND IF IS SUCCESSFULL THE ROUTER WILL GO TO THE NEXT SCREEN

export const ScreenControl = ({
    children, parentClasses = [], dimensions = { minWidth: "100%" }, disabled = true, showGoBack = true,
    beforeSubmit = null, beforeGoBack = null, index = null, path = null, btnText = null, icon = null, btncolor=null
}) => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const moveIndex = (direction) => {
        if (direction === "forward") {
            if (!index?.fw) dispatch(forward());
            else {
                if (index.fw > -1) dispatch(jump({ current: index.fw, direction: "forward" }));
                else dispatch(jump({ current: index.fw, path, direction: "forward" }));
            }
        }
        else {
            if (index?.bw == null) dispatch(backward());
            else {
                if (index.bw > -1 && !path) dispatch(jump({ current: index.bw, direction: "backward" }));
                else dispatch(jump({ current: index.bw, path, direction: "backward" }));
            }
        }
    }

    const goForward = () => {

        if (disabled || loading) return false;

        // IF THERE IS NO ACTION TO TRIGGER BEFORE CHANGIN SCREEN
        if (!beforeSubmit) moveIndex("forward");

        // IF AN ACTION IS REQUIRED TO BE EXECUTED, THE FUNCTION MUST RETURN true OR false
        // IF true THE SCREEN WILL CHANGE OTHERWISE IS NOT
        else (async () => {
            setLoading(true);   // DISPLAY LOADING ICON
            let go = await new Promise(resolve => resolve(beforeSubmit())); // EXECUTE CALLBACK

            setLoading(false);  // HIDE LOADING ICON
            if (go) moveIndex("forward");   // CHANGE PAGE
        })()
    }

    const goBackward = () => {

        // IF THERE IS NO ACTION TO TRIGGER BEFORE CHANGIN SCREEN
        if (!beforeGoBack) moveIndex("backward");

        // IF AN ACTION IS REQUIRED TO BE EXECUTED, THE FUNCTION MUST RETURN true OR false
        // IF true THE SCREEN WILL CHANGE OTHERWISE IS NOT
        else (async () => {
            setLoading(true);   // DISPLAY LOADING ICON
            let go = await new Promise(resolve => resolve(beforeGoBack())); // EXECUTE CALLBACK

            setLoading(false);  // HIDE LOADING ICON
            if (go) moveIndex("backward");  // CHANGE PAGE
        })()
    }

    // DEFAULT COMPONENTS
    if (!children) return (
        <Stack
            flex={{
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center"
            }}
            sx={{ ...dimensions }}
        >
            {/* GO BACK BUTTON */}
            {showGoBack && (
            < Button 
                style={{
                    position: "fixed",
                    top: "1.5rem",
                }} 
                classes={["btnBackward", "alignBtnContent", "transparentBtn"]}
                onClick={goBackward}
            >
                <ArrowBackIos fontSize='small' />
            </Button>)}

            {/* CONTINUE BUTTON */}
            <Button key={"asd"} classes={["marginTB1em","btnForward", "alignBtnContent", (disabled || loading) ? "" : (btncolor? btncolor : "purpleBtn")]} onClick={goForward}>
                {
                    !loading ? <>
                        {!btnText ? "Continuar" : btnText}
                        {!icon ? icon : <ArrowForward fontSize='small' sx={{ marginLeft: '0.5em' }} />}
                    </> :
                        <LoadingIcon></LoadingIcon>
                }
            </Button>
        </Stack>
    );
    // CUSTOM COMPONENTS
    return (
        <Button classes={parentClasses} onClick={goForward}>
            {children}
        </Button>
    );
}